<template>
  <!-- :class="isSelect ? 'selectBtn' : 'unSelectBtn'" -->
  <div
    @click="clickBtn"
    class="phoneTypeBtnContent"
    :style="
    'background-color:' + (isSelect ? selectBackColor : '') + ';' +
    'border: ' + (!isSelect ? ('2px solid' + nomalBorderColor) : '') + ';'
    
    ">
    <img style="width: 48px; height: 48px" :src="isSelect ? selectIconText : nomalIcon" />
    <div class="btnTitle" :style="
    'color:' + (isSelect ? selectTextColor : nomalTextColor) + ';' +
    'font-size:' + textFontSize + 'px;' +
    'margin-left:' + textPadding + 'px;'

    ">{{ titleText }}</div>
  </div>
</template>

<script>
export default {
  name: "phoneTypeBtn",

  props: {

    titleText: {
      type: String,
      required: true,
      default: "",
    },
    //选中状态下的图标
    selectIconText: {
      type: String,
      required: true,
      default: "",
    },

    //默认状态下的图标
    nomalIcon: {
      type: String,
      required: true,
      default: "",
    },

    isSelect: {
      type: Boolean,
      required: false,
      default: false,
    },

    selectTextColor: {
      type: String,
      required: false,
      default: "#FFFFFF",
    },

    nomalTextColor: {
      type: String,
      required: false,
      default: "#FFFFFF",
    },

    selectBackColor: {
      type: String,
      required: false,
      default: "#3561FF",
    },

    nomalBorderColor: {
      type: String,
      required: false,
      default: "#FFFFFF",
    },
    textFontSize: {
      type: Number,
      required: false,
      default: 24,
    },
    textPadding: {
      type: Number,
      required: false,
      default: 28,
    },
  },
  methods: {
    clickBtn() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.phoneTypeBtnContent {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 48px;
  overflow: hidden;
}

.btnTitle {
  margin-left: 28px;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.selectBtn {
  background: rgba(53, 97, 255, 1);
}

.unSelectBtn {
  border: 2px solid rgba(255, 255, 255, 1);
}
</style>